import { inventoryVendorService } from "../../../../../Api/Services/InventoryService/inventoryVendor";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";
import { IInventoryVendorPayload, ICreateInventoryVendorResponse } from "../../types";

// 1. Thunk for saving/updating
export const saveUpdateInventoryVendor = createServiceAsyncThunk<
    ICreateInventoryVendorResponse,
    { formData: FormData }
>(
    ACTION_NAMES.SAVE_UPDATE_INVENTORY_VENDOR,
    ({ formData }) => inventoryVendorService.saveOrUpdateInventoryVendor(formData),
    ERROR_MESSAGES.SAVE_UPDATE_INVENTORY_VENDOR_FAILURE
);

// 2. Generic Slice
const saveUpdateInventoryVendorSlice = createGenericSlice<
    ICreateInventoryVendorResponse,
    { formData: FormData }
>(
    SLICE_NAMES.SAVE_UPDATE_INVENTORY_VENDOR_SLICE,
    saveUpdateInventoryVendor
);

export const {
    clearError: clearSaveInventoryVendorError,
    clearSuccessMessage: clearSaveInventoryVendorSuccessMessage,
} = saveUpdateInventoryVendorSlice.actions;

export default saveUpdateInventoryVendorSlice.reducer;